/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ConfirmAction/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'



/** @type {import('Simple/types.js').View} */
export default function ConfirmAction({
  children,
  viewPath = "/DesignSystem/CancelAppointment/ConfirmationDialog/Content/ConfirmAction",
  onSubmit,
  isSubmitting
  
}) {
let cancelAppointmentSubmitData = fromData.useDataSubmit({ viewPath,
context: 'cancel_appointment',
})
let cancelAppointmentIsSubmittingData = fromData.useDataIsSubmitting({ viewPath,
context: 'cancel_appointment',
})
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 data="cancel_appointment"
 onClick={cancelAppointmentSubmitData}
 disabled={cancelAppointmentIsSubmittingData}
>
{childProps => (
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 text="Confirm"
/>
)}
</TysiaButton>
{children}
</React.Fragment>)
}